export interface User {
  balance: string;
  id: number;
  username: string;
  email: string;
}

export type Status =
  | "NEW"
  | "STARTING"
  | "IN_PROGRESS"
  | "PAUSED"
  | "CHECKING"
  | "COMPLETED"
  | "CANCELED"
  | "ERROR"
  | "PENDING"
  | "FAILED";

export type ViewsMode = "CUSTOM" | "ORGANIC";

export interface PostOrder {
  id: number;
  post_link: string;
  speed: number;
  start_views: { value: number; title: string };
  status: { value: Status; title: string };
  views: { value: number; title: string };
  created_at: string;
  completed_views: { value: number; title: string };
  channel: { picture: string; title: string };
  awaiting_views: { value: number; title: string };
  real_views: { value: number; title: string };
  post_id: number;
  views_mode: { value: ViewsMode; title: string };
  price: string;
  include_other_sources: boolean;
}

export interface PostOrderPayload {
  post_link: string;
  views: number;
  speed: number;
  views_mode: ViewsMode;
  include_other_sources: boolean;
}

export interface EditPostOrderPayload {
  views: number;
  speed: number;
}

export type ChannelOrderType = "PAST_POSTS" | "FUTURE_POSTS";

export interface ChannelOrder {
  id: number;
  channel: { title: string; picture: string };
  channel_link: string;
  created_at: string;
  expiration_at: { time_left: string; value: string };
  orders_count: { value: number; title: string };
  posts_count: { value: number; title: string };
  random: number | null;
  speed: number;
  type: ChannelOrderType;
  status: { value: Status; title: Status };
  views: { value: number; title: string };
  views_mode: { value: ViewsMode; title: string };
  include_other_sources: boolean;
}

export interface ChannelOrderPayload {
  channel: string;
  speed: number;
  views: number;
  random: number;
  type: ChannelOrderType;
  posts_count: number;
  expiration_at: string;
  views_mode: ViewsMode;
  include_other_sources: boolean;
}

export interface EditChannelOrderPayload {
  speed: number;
  views: number;
  random: number;
  posts_count: number;
  expiration_at: string;
  include_other_sources: boolean;
}

export interface PlanCurrent {
  id: number;
  name: string;
  is_trial: boolean;
  speed: number;
  speed_for_one: number;
  auto_renewal: boolean;
  price: number;
  expiration_time: string;
}

export interface Overview {
  channel_orders: number;
  current_speed: number;
  loading: number;
  plan_speed: number;
  post_orders: number;
}

export type PlanAction = "activate" | "upgrade" | "nothing";

export interface Plan {
  id: number;
  name: string;
  price: number;
  price_with_discount: number;
  duration: string;
  is_trial: boolean;
  speed: number;
  speed_for_one: number;
  action: PlanAction;
  refund: number | null;
}

export interface ApiKey {
  id: number;
  key: string;
  expiration_at: string | null;
  read_only: boolean;
}

export interface ApiKeyPayload {
  read_only: boolean;
  expiration_at: string | null;
}

export interface TopupPayload {
  amount: number;
  type: "PAYCRYPTO" | "YOOKASSA";
}

export interface Price {
  level: number;
  views_price: string;
}

export interface Level {
  level: number;
  amount: number;
}

export enum LanguagesEnum {
  RU = "ru",
  EN = "en",
}

export interface BillingOverview {
  level: number;
  next_month_level: number;
  current_month_replenishment: number;
  previous_month_replenishment: number;
}

export interface ExpensesOverview {
  today: string;
  yesterday: string;
}

export interface Expense {
  day: string;
  amount: string;
}

export interface Replenishment {
  id: number;
  type: "PAYCRYPTO" | "YOOKASSA";
  status: Status;
  amount: number;
  url: string;
  created_at: string;
}
